import React from 'react';

import AwsUploadCommandGenerator from './AwsUploadCommandGenerator';
import { CliCommandBlock } from './CopyableCliBlock';
import { OperatingSystem } from './cliInstructionTypes';

const getSourcePathPlaceholders = (selectedOs: OperatingSystem) => {
  if (selectedOs === 'windows') {
    return {
      recursive: 'C:\\Users\\name\\Desktop\\slides',
      singleFile: 'C:\\Users\\name\\Desktop\\slide1.svs',
    };
  }

  if (selectedOs === 'linux') {
    return {
      recursive: '/home/name/slides',
      singleFile: '/home/name/slide1.svs',
    };
  }

  return {
    recursive: '/Users/name/Desktop/slides',
    singleFile: '/Users/name/Desktop/slide1.svs',
  };
};

const LocalAwsUploadCommandGenerator = ({
  awsProfileName,
  destination,
  selectedOs,
  sourcePathInstructions,
}: {
  awsProfileName: string;
  destination: string;
  selectedOs: OperatingSystem;
  sourcePathInstructions?: React.ReactNode;
}) => {
  return (
    <AwsUploadCommandGenerator
      copyableCommandBlock={(command) => <CliCommandBlock command={command} />}
      destination={destination}
      intro="Enter the file or folder path from your computer. We will build the full AWS CLI command for you."
      sourcePathInstructions={sourcePathInstructions}
      sourceLabels={{ recursive: 'Source folder path', singleFile: 'Source file path' }}
      sourcePlaceholders={getSourcePathPlaceholders(selectedOs)}
      uploadOptions={awsProfileName ? [`--profile ${awsProfileName}`] : []}
    />
  );
};

export default LocalAwsUploadCommandGenerator;
